function getGclidFromLocalStorage() {
    return window.localStorage.getItem('gclid');
}

const GAds = {
    getGclid: () => {
        return getGclidFromLocalStorage();
    },
}

export default GAds;